import React from 'react'
import MailchimpSubscribe from 'react-mailchimp-subscribe'

import SubscribeForm from './SubscribeForm'

const url = '//triptcip.us1.list-manage.com/subscribe/post?u=444033a5bf2888a620280e060&amp;id=6b03097cb1'

const SubscribeMailchimp = ({ onClose, onSubscribed, autoFocus }) => {
  const handleSubscribed = () => {
    onSubscribed && onSubscribed()
  }

  return (
    <MailchimpSubscribe
      url={url}
      render={props => {
        return (
          <SubscribeForm
            onSubscribed={handleSubscribed}
            onClose={onClose}
            autoFocus={autoFocus}
            {...props}
          />
        )
      }}
    />
  )
}

export default SubscribeMailchimp
